const seenServiceName = "/SeenManagement";

export function seenService(http) {
    return {
        saveSeenAsync: async (userId, applicationId, seenType, tableName, tableId) => {
            let seenRequest = {
                userId, 
                applicationId, 
                seenType, 
                tableName, 
                tableId
            };
            return await http.post(seenServiceName + "/SaveSeenAsync", seenRequest)
        }
    }
}
